module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (89).46b24cf9.jpg";